import { Badge, Button, Card } from "@artisan/ui";
import { CloudOff, CloudUpload, RefreshCw } from "lucide-react";
import { Link } from "react-router";

import { Screen } from "../components/screen";
import { useOwner } from "../lib/hooks";
import { relativeMn } from "../lib/time";
import { kick, useOutboxStatus } from "../outbox/outbox";
import { projectTitle } from "../project/actions";
import { listProjects, useProjectsVersion } from "../project/store";

export function OutboxScreen() {
  const owner = useOwner();
  useProjectsVersion();
  const status = useOutboxStatus();
  const rows = listProjects(owner)
    .flatMap((p) => p.revisions.map((r) => ({ p, r })))
    .sort((a, b) => b.r.created_at.localeCompare(a.r.created_at));
  return (
    <Screen
      title="Илгээх дараалал"
      subtitle={status.online ? (status.pending ? `${status.pending} хүлээгдэж байна` : "Бүгд илгээгдсэн") : "Офлайн: сүлжээ орж ирэхэд автоматаар илгээнэ"}
      actions={
        <Button variant="outline" size="lg" icon={RefreshCw} disabled={status.sending} onClick={() => void kick()}>
          Одоо илгээх
        </Button>
      }
    >
      {!status.online ? (
        <Card className="mb-5 flex items-center gap-3 border-warning/40 bg-warning-soft p-4 text-sm">
          <CloudOff className="size-5 text-warning" aria-hidden /> Интернэт алга. Хэмжилтүүд энэ төхөөрөмжид аюулгүй хадгалагдсан.
        </Card>
      ) : null}
      {rows.length === 0 ? (
        <Card className="grid place-items-center gap-2 border-dashed py-14 text-center">
          <CloudUpload className="size-7 text-muted-foreground" aria-hidden />
          <p className="font-medium">Илгээсэн хэмжилт алга</p>
        </Card>
      ) : (
        <Card className="divide-y p-0">
          {rows.map(({ p, r }) => (
            <Link key={r.revision_id} to={`/p/${p.id}/send`} className="flex items-center gap-4 px-5 py-4 hover:bg-accent">
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium">
                  {projectTitle(p)} {r.revision_no ? `· v${r.revision_no}` : ""}
                </p>
                <p className="text-xs text-muted-foreground">
                  {relativeMn(r.created_at)} · {(r.size_bytes / 1024).toFixed(1)} KB
                  {r.photos_pending ? ` · ${r.photos_pending} зураг хүлээгдэж байна` : ""}
                </p>
              </div>
              <Badge variant={r.state === "sent" ? "success" : r.state === "rejected" ? "destructive" : "warning"}>
                {r.state === "sent" ? "Хүлээн авсан" : r.state === "rejected" ? "Татгалзсан" : "Дараалалд"}
              </Badge>
            </Link>
          ))}
        </Card>
      )}
    </Screen>
  );
}
